import {
  UPDATE_EMAIL_ACCOUNT,
  UpdateEmailAccountType,
  UpdateEmail,
  UPDATE_EMAIL_ACCOUNT_RESET,
} from '../../../types/applicant/account/updateEmail'

export const updateEmail = (data: UpdateEmailAccountType): UpdateEmail => {
  return {
    type: UPDATE_EMAIL_ACCOUNT,
    payload: data,
  }
}

export const resetUpdateEmail = () => {
  return {
    type: UPDATE_EMAIL_ACCOUNT_RESET,
    payload: null,
  }
}
